import makeStyles from 'utils/makeStylesCompat'

const genericStyles = makeStyles(theme => ({
  container: {
    padding: '24px',
  },
  filterIcon: {
    color: theme?.palette?.text?.primary,
  },
  // Flat wrapper — the table renders its own bordered card (CRM standard).
  outerTablePaper: {
    width: '100%',
    backgroundColor: 'transparent',
    marginTop: '16px',
    boxShadow: 'none',
    padding: '16px',
    borderRadius: '8px',
  },
  paperTable: {
    width: '100%',
    backgroundColor: theme?.palette?.background?.default,
    marginTop: '4px',
    boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.12)',
    padding: '16px',
    borderRadius: '8px',
    border: '1px solid #EAECF0',
  },
  paperTableNoPadding: {
    width: '100%',
    backgroundColor: theme?.palette?.background?.default,
    marginTop: '4px',
    boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.12)',
    padding: '0px',
    borderRadius: '16px',
    overflow: 'hidden',
    border: '1px solid #EAECF0',
  },
  // CRM standard: flat layout wrapper (see outerTablePaper).
  outerTablePaperTwo: {
    width: '100%',
    backgroundColor: 'transparent',
    boxShadow: 'none',
    padding: '16px',
    borderRadius: '8px',
  },
  filterPaper: {
    marginTop: '16px',
    padding: '8px 0px',
    backgroundColor: theme?.palette?.background?.default,
  },
  filterPaperNoPadding: {
    marginTop: '16px',
    padding: '0px',
    backgroundColor: theme?.palette?.background?.default,
  },
  noDataPageContainer: { height: `calc(100vh - 250px)` },
  noDataContainer: { height: `calc(100vh - 280px)` },

  noDataPageInnerContainer: { padding: '24px' },
  noDataPageIcon: { color: theme?.palette?.text?.secondary },
  noDataPageTitle: { fontWeight: '600' },
  noDataPageContent: { marginTop: '12px' },
  noDataPageButton: {
    marginTop: '28px',
    backgroundColor: theme?.palette?.secondary?.light,
  },
  headerBox: {
    margin: '0px 24px',
    padding: '12px 0px',
    borderBottom: '1px solid',
    borderColor: `${theme?.palette?.secondary?.main} !important`,
    minHeight: '86px',
  },
  headerBoxInLayout: {
    margin: '0px 24px',
    padding: '12px 0px',
  },
  searchBox: {
    border: `1px solid #D0D5DD`,
    borderRadius: '8px',
    padding: '2px 8px',
    width: '350px',
  },
  searchBoxUnmapped: {
    width: '350px',
    height: '40px',
    gap: '8px',
    p: '16px 14px',
    borderRadius: '6px',
    borderWidth: '1px',
    border: `1px solid #D0D5DD`,
  },
  searchBoxInsurance: {
    border: `1px solid #D0D5DD`,
  },
  tableTitle: {
    variant: 'h4',
    fontWeight: '600',
  },

  labelTypography: {
    color: theme?.palette?.mode === 'light' ? 'rgba(0, 0, 0, 0.6)' : '#fff',
  },
  infoChip: {
    borderColor: theme?.palette?.secondary?.main,
    backgroundColor: 'rgba(61, 85, 103, 0.08);',
    margin: '3px',
  },
  infoChipOrg: {
    borderColor: theme?.palette?.secondary?.main,
    backgroundColor: '#00B4801F',
    color: '#4A4459',
    margin: '3px',
  },
  noAccessPageDiv: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
  },
  noAccessPagePaper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '32px',
    margin: '16px',
  },
  centerTypography: {
    height: '85vh',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '16px',
  },
  deleteIconColor: {
    color: '#EF9A9A',
  },
  deleteIconDisableColor: {
    color: theme?.palette?.mode === 'light' ? '#d6d9d4' : 'rgba(61, 85, 103, 0.5)',
  },
  editIconColor: {
    color: theme?.palette?.mode === 'light' ? 'rgba(61, 85, 103, 0.5)' : '#d6d9d4',
  },
  editIconDisableColor: {
    color: theme?.palette?.mode === 'light' ? '#d6d9d4' : 'rgba(61, 85, 103, 0.5)',
  },
  downloadIconColor: {
    color: theme?.palette?.mode === 'light' ? '#5B7F9A' : '#d6d9d4',
  },
  downloadIconDisableColor: {
    color: theme?.palette?.mode === 'light' ? '#d6d9d4' : 'rgba(61, 85, 103, 0.5)',
  },
  logoSize: {
    height: '56px',
    width: '174px',
  },
  homePageLogoSize: {
    width: '158px',
    height: '58px',
    outline: 'none',
  },
  acceptAllOrDenyAllBtns: {
    fontSize: '15px',
    fontWeight: 400,
  },
  logoStyle: {
    width: '65px',
    height: '61px',
  },
  description: {
    lineHeight: '19.92px',
    letterSpacing: '0.42px',
    color: theme?.palette?.gccCustomColors?.textDescription,
  },
  profileChips: {
    backgroundColor: theme?.palette?.gccCustomColors?.lightGreen,
    marginRight: '10px',
    marginBottom: '8px',
    border: 'none',
  },
  searchBoxPersist: {
    border: `1px solid #D0D5DD`,
    borderRadius: '8px',
    padding: '2px 4px',
    width: '260px',
  },
  editBtnColor: {
    color: theme?.palette?.mode === 'light' ? '#475467' : '#d6d9d4',
  },
  editBtnDisableColor: {
    color: theme?.palette?.mode === 'light' ? '#d6d9d4' : '#475467',
  },
  enhancedTablePaper: {
    width: '100%',
    backgroundColor: theme?.palette?.background?.default,
    marginTop: '6px',
    boxShadow: '0px 1px 3px rgba(234, 236, 240, 1)',
    paddingY: '8px',
    borderRadius: '12px',
    border: '1px solid rgba(234, 236, 240, 1)',
  },
  editButtonColor: {
    color: '#5B7F9A',
  },
  editButtonDisabledColor: {
    color: '#d6d9d4',
  },
  deleteButtonColor: {
    color: '#D32F2F',
  },
  deleteButtonDisabledColor: {
    color: '#d6d9d4',
  },
}))
export default genericStyles
